import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/add-icon.png';
const _withScopeId = (n) => (_pushScopeId("data-v-882cf068"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "img-container" };
const _hoisted_2 = { class: "title" };
const _hoisted_3 = { class: "img-block" };
const _hoisted_4 = ["src"];
const _hoisted_5 = ["onClick"];
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("img", {
    src: _imports_0,
    alt: "add"
}, null, -1));
import { ref, computed, toRaw } from "vue";
import { useStore } from "vuex";
import { TowVehicleServiceBookingStatus, } from "../../interfaces/main-data";
import { TowVehicleMediaType, } from "../../interfaces/tow-vehicle-media";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ImageGallery',
    props: {
        data: {},
        title: {},
        status: {}
    },
    setup(__props) {
        const store = useStore();
        const images = computed(() => store.getters.allImages);
        const allImages = toRaw(images.value);
        const startIndex = status === TowVehicleServiceBookingStatus.ARRIVED
            ? 0
            : allImages?.filter((x) => x.status === TowVehicleServiceBookingStatus.ARRIVED).length - 1;
        const fileInput = ref(null);
        const towVehicleStatus = computed(() => store.getters.towVehicleStatus);
        const isDestinationReached = computed(() => store.getters.isDestinationReached);
        // Define props
        const triggerFileUpload = () => {
            fileInput.value?.click();
        };
        const handleFileUpload = (event) => {
            const target = event.target;
            if (target.files && target.files[0]) {
                const file = target.files[0];
                store.dispatch("uploadImage", file);
            }
        };
        const imagesForStatus = computed(() => {
            return images.value.filter((e) => towVehicleStatus.value === TowVehicleServiceBookingStatus.PICKUP
                ? e.type === TowVehicleMediaType.COMPLETED
                : towVehicleStatus.value === TowVehicleServiceBookingStatus.STARTED
                    ? e.type === TowVehicleMediaType.ARRIVED
                    : e.type === towVehicleStatus.value);
        });
        const imagesForRemove = computed(() => {
            return (img) => {
                if (towVehicleStatus.value === TowVehicleServiceBookingStatus.PICKUP) {
                    return img.type === TowVehicleMediaType.COMPLETED;
                }
                else if (towVehicleStatus.value === TowVehicleServiceBookingStatus.STARTED) {
                    return img.type === TowVehicleMediaType.ARRIVED;
                }
                else {
                    return img.type === towVehicleStatus.value;
                }
            };
        });
        const towVehicleMediaStatus = computed(() => {
            if (towVehicleStatus.value === TowVehicleServiceBookingStatus.PICKUP) {
                return TowVehicleMediaType.COMPLETED;
            }
            else if (towVehicleStatus.value === TowVehicleServiceBookingStatus.STARTED) {
                return TowVehicleMediaType.ARRIVED;
            }
            else {
                return towVehicleStatus.value;
            }
        });
        const removeImage = (index) => {
            store.dispatch("removeImage", index + startIndex);
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.title), 1),
                _createElementVNode("div", _hoisted_3, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(images.value.filter((e) => e.type === _ctx.status), (image, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                            class: "img-box",
                            key: index
                        }, [
                            _createElementVNode("figure", null, [
                                _createElementVNode("img", {
                                    src: image.location,
                                    alt: "photos"
                                }, null, 8, _hoisted_4)
                            ]),
                            (imagesForRemove.value(image))
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: "del",
                                    onClick: ($event) => (removeImage(index))
                                }, " Delete ", 8, _hoisted_5))
                                : _createCommentVNode("", true)
                        ]));
                    }), 128)),
                    (((towVehicleStatus.value === _unref(TowVehicleServiceBookingStatus).PICKUP &&
                        isDestinationReached.value &&
                        imagesForStatus.value.length > 0) ||
                        (towVehicleStatus.value === _unref(TowVehicleServiceBookingStatus).STARTED &&
                            isDestinationReached.value) ||
                        (towVehicleStatus.value === _unref(TowVehicleServiceBookingStatus).ARRIVED &&
                            isDestinationReached.value)) &&
                        towVehicleMediaStatus.value === _ctx.status)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "add-img",
                            onClick: triggerFileUpload
                        }, [
                            _hoisted_6,
                            _createTextVNode(" Add more ")
                        ]))
                        : _createCommentVNode("", true),
                    _createElementVNode("input", {
                        type: "file",
                        ref_key: "fileInput",
                        ref: fileInput,
                        onChange: handleFileUpload,
                        style: { "display": "none" },
                        accept: "image/*"
                    }, null, 544)
                ])
            ]));
        };
    }
});
